import React from "react";
import compose from "recompose/compose";
import Button from "theme/components/atoms/Button";
import { H3 } from "theme/components/atoms/Typography/Heading";
import Link from "theme/components/atoms/Typography/Link";
import withLogoutMutation from "theme/modules/User/Logout/withLogoutMutation";
import withIsWishlistEnabled from "theme/modules/Wishlist/withIsWishlistEnabled";
import { FormattedMessage } from "react-intl";
import Svg from "theme/components/atoms/Icon/Svg";
import { withCookies } from "react-cookie";

const AccountSubNavigation = ({
  user,
  logout,
  commandPending,
  wishlist,
  onCloseMenu,
  cookies,
}) => {
  return (
    <div className="account-sub-navigation">
      <div className="account-sub-navigation__header">
        <H3>
          <FormattedMessage
            id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.welcome"
            defaultMessage="Welcome {name}!"
            values={{ name: user.firstname }}
          />
        </H3>
        <Button appearance="icon-header" onClick={onCloseMenu}>
          <Svg type="close" />
        </Button>
      </div>
      <ul className="account-sub-navigation__list">
        <li className="account-sub-navigation__item">
          <Link to="/user">
            <FormattedMessage
              id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.dashboard"
              defaultMessage="My dashboard"
            />
          </Link>
        </li>
        <li className="account-sub-navigation__item">
          <Link to="/user/orders">
            <FormattedMessage
              id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.orders"
              defaultMessage="My orders"
            />
          </Link>
        </li>
        {wishlist?.isFeatureActive ? (
          <li className="account-sub-navigation__item">
            <Link to="/user/wishlist">
              <FormattedMessage
                id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.wishlist"
                defaultMessage="My wishlist"
              />
            </Link>
          </li>
        ) : null}
        <li className="account-sub-navigation__item">
          <Link to="/contact">
            <FormattedMessage
              id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.contact"
              defaultMessage="Contact"
            />
          </Link>
        </li>
        <li className="account-sub-navigation__item account-sub-navigation__item--logout">
          <Button
            appearance="link"
            state={commandPending ? "pending" : undefined}
            onClick={() => {
              cookies.set("logged", "logout");
              logout("/");
            }}
          >
            <FormattedMessage
              id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.logout"
              defaultMessage="Log out"
            />
          </Button>
        </li>
      </ul>
    </div>
  );
};

export default compose(
  withIsWishlistEnabled(),
  withLogoutMutation(),
  withCookies
)(AccountSubNavigation);
